import TeammateForm from '@/components/teammates/forms/TeammateForm';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import { ROUTES } from '@/constants/routes';
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { initalTeammateForm } from '@/constants/teammates';
import { useGetUser } from '@/hooks/requests/useUser';
import { useAuthUser } from '@/hooks/stores/useAuthUser';
import { UserRoles } from '@/types/user';

export default function TeammateAddPage() {
  const navigate = useNavigate();
  const { isStaff } = useAuthUser();
  const { user } = useGetUser();
  const [searchParams] = useSearchParams();
  const companyId = isStaff
    ? searchParams.get('companyId')
    : user?.teammateInfo?.company.uuid;

  const isSupporter = user?.role === UserRoles.TEAMMATE_SUPPORTER;
  if (isSupporter) {
    return <Navigate to={ROUTES.TEAMMATES} replace />;
  }

  return (
    <DefaultLayout
      header="Add Teammate"
      breadcrumb={[
        { label: 'Teammates', href: ROUTES.TEAMMATES },
        { label: 'Add', isActive: true },
      ]}>
      <TeammateForm
        onSuccess={(uuid: string) => navigate(`${ROUTES.TEAMMATES}/${uuid}`)}
        defaultValues={{ ...initalTeammateForm, companyId: companyId || '' }}
      />
    </DefaultLayout>
  );
}
